import CustomTitleWithSwitch from "components/base/CustomTitleWithSwitch";
import { ReactHookFormErrorMessage } from "components/base/ErrorFieldMessage";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

const ReactHookFormSwitch = ({
  customTitleClass = "",
  title = "",
  titlePopoverDetail,
  titlePopOverImage,
  tips,
  tipsPopoverDetail,
  bottomDescription,
  valueFieldName,
  extraActionOnChange = () => { },
  disabled = false,
  defaultTrue = false,
}) => {
  const dispatch = useDispatch()
  const formContext = useFormContext()
  const {
    setValue,
    watch,
    formState: { errors }
  } = formContext;
  
  const watchValue = watch(valueFieldName)

  useEffect(()=> {
    if (watchValue === undefined && defaultTrue) {
      setValue(valueFieldName, defaultTrue, { shouldDirty: true })
      extraActionOnChange && extraActionOnChange({
        dispatch,
        formContext,
        value: defaultTrue,
      })
    }
  }, [watchValue, defaultTrue])

  return (<>
    <CustomTitleWithSwitch
      disabled={disabled}
      customTitleClass={customTitleClass}
      title={title}
      titlePopoverDetail={titlePopoverDetail}
      titlePopOverImage={titlePopOverImage}
      defaultValue={defaultTrue && watchValue === undefined ? true : watchValue}
      tips={tips}
      tipsPopoverDetail={tipsPopoverDetail}
      bottomDescription={bottomDescription}
      setValue={(value) => {
        setValue(valueFieldName, value, { shouldDirty: true })
        extraActionOnChange && extraActionOnChange({
          dispatch,
          formContext, 
          value,
        })
      }}
    />
    <ReactHookFormErrorMessage
      id={valueFieldName}
      errors={errors}
    />
  </>)
}

export default ReactHookFormSwitch;